<template>
  <div>
    <div class="third-rea">
      <div class="third-btn">
        <div class="btn-left">检索条件</div>
        <div class="btn-right">
          <el-button class="btn-two" type="primary" @click="searchInput"
            >查询</el-button
          >
          <el-button class="btn-two" type="default" @click="resetInput"
            >重置</el-button
          >
          <span class="btn-shu"></span>
          <el-button
            class="btn-four"
            type="default"
            icon="el-icon-search"
            @click="hignSearch"
            >高级检索</el-button
          >
        </div>
      </div>
      <div class="third-search">
        <el-form
          :inline="true"
          :model="formInline"
          label-width="76px"
          @keyup.native.enter="searchInput"
        >
          <div class="search-row">
            <div class="row-item">
              <el-form-item label="客户端">
                <el-select
                  class="item-input"
                  v-model="formInline.appType"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="iOS" value="1"></el-option>
                  <el-option label="安卓" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="版本号">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model="formInline.version"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="构建编号">
                <el-input
                  class="item-input"
                  :maxlength="30"
                  v-model="formInline.versionCode"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="更新类型">
                <el-select
                  class="item-input"
                  v-model="formInline.updateType"
                  clearable
                  placeholder="请选择"
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="强制更新" value="1"></el-option>
                  <el-option label="推荐更新" value="2"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="row-item">
              <el-form-item label="更新时间">
                <el-date-picker
                  class="item-input"
                  v-model="formInline.updateTime"
                  type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  :default-time="['00:00:00', '23:59:59']"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="third-one service-list">
      <div class="third-do-btn">
        <div class="do-btn-left">
          <el-button
            class="do-btn-four"
            type="default"
            icon="el-icon-plus"
            @click="addPage"
            >发布更新</el-button
          >
          <el-button
            class="do-btn-four"
            type="default"
            icon="el-icon-delete"
            @click="handleSelectDel"
            >删除</el-button
          >
        </div>
        <div class="do-btn-right">
          <div class="do-btn-check">
            <el-checkbox
              class="btn-check-item"
              v-model="checked"
              @change="changeHign"
            ></el-checkbox>
            <span class="btn-check-span">显示高级功能</span>
          </div>
          <div class="do-btn-hign-list" v-if="checked">
            <!-- 展示字段 -->
            <sort-data
              :tableRow="tableRow"
              @showList="getTableList"
              sessionOriginalName="APPVersionsManSortOrignalData"
              sessionResultName="APPVersionsManSortData"
            ></sort-data>
            <!-- 数据顺序 -->
            <display-field
              :selectList="tableRow"
              sessionOriginalName="APPVersionsManDisplayFiedOrignal"
              @setDataOrder="getDataOrder"
              sessionResultName="APPVersionsManDisplayFied"
            ></display-field>
          </div>
        </div>
      </div>
      <el-table
        class="third-tableThree tableThree-heightOth"
        :data="tableData"
        border
        stripe
        @selection-change="handleSelectChange"
        row-key="otherUserId"
        ref="otherUserId"
        v-loading="loading"
      >
        <el-table-column type="selection" width="32px" reserve-selection>
        </el-table-column>
        <template v-for="(item, index) in tableDataShow">
          <el-table-column
            v-if="item.needKeyValue"
            min-width="100px"
            :prop="item.key"
            :label="item.column"
            :key="index"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="{ row }">
              <span>
                {{ row.releaseTime | getTime }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            min-width="100px"
            :prop="item.key"
            :label="item.column"
            :key="index"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>
                {{ getlable(scope.row, item.key) }}
              </span>
            </template>
          </el-table-column>
        </template>
        <!-- <el-table-column label="下载">
          <template slot-scope="scope">
            <el-button
              :disabled="scope.row.appType === '1'"
              type="text"
              size="small"
              @click="download(scope.row.updateUrl)">
              下载
            </el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              :disabled="scope.row.appType === '1'"
              type="text"
              size="small"
              @click="download(scope.row.updateUrl)"
            >
              下载
            </el-button>
            <span class="table-middle_line"></span>
            <el-button type="text" size="small" @click="edit(scope.row)">
              编辑
            </el-button>
            <span class="table-middle_line"></span>
            <el-button
              type="text"
              size="small"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="third-page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          background
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </div>
    <hign-modal
      :hignModalVisible="hignModal"
      @searchModal="toHignSearch"
      @cancelModal="closeModal"
      :hignOneList="tableRow"
    ></hign-modal>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    >
    </notice-modal>
  </div>
</template>

<script>
import { getStore, setStore } from "@/utils/store";

export default {
  name: "thirdThree",
  data() {
    return {
      loading: false,
      noticeSpec: "是否确认删除？", // 标红提示
      noticeType: 1, // 提示类型
      agreeContent: "删除", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "", // 提示信息
      noticeModal: false, // 提示弹窗
      pageSize: 40,
      pageIndex: 1,
      totalNum: 0, // 总数
      tableData: [],
      hignModal: false, // 高级搜索
      formInline: {
        appType: "",
        version: "",
        versionCode: "",
        updateType: "",
        updateTime: [],
      },
      selectArrList: [], // 批量移除
      nowSelectArr: [], // 移除数组
      isDeleteList: false, // 是否批量删除
      hignSearchRes: "", // 高级检索条件
      tableDataShow: [
        {
          column: "客户端",
          key: "appType",
          needKeyValue: false,
          caseKey: "pav.app_type",
        },
        {
          column: "版本号",
          key: "version",
          needKeyValue: false,
          caseKey: "pav.version",
        },
        {
          column: "构建编号",
          key: "versionCode",
          needKeyValue: false,
          caseKey: "pav.version_code",
        },
        {
          column: "更新内容",
          key: "remark",
          needKeyValue: false,
          caseKey: "pav.remark",
        },
        {
          column: "下载链接",
          key: "updateUrl",
          needKeyValue: false,
          caseKey: "pav.update-url",
        },
        {
          column: "更新类型",
          key: "updateType",
          needKeyValue: false,
          caseKey: "pav.update_type",
        },
        {
          column: "更新时间",
          key: "updateTime",
          needKeyValue: false,
          caseKey: "pav.update_time",
        },
      ],
      orderConfig: "", // 字段展示和顺序需要的参数
      checked: true,
      statusData: {}, // 状态params
      delId: "", // 删除ID
      tableRow: [
        // 所有字段
        {
          column: "客户端",
          key: "appType",
          needKeyValue: false,
          caseKey: "pav.app_type",
          isCustomList: [
            {
              label: "iOS",
              value: "1",
            },
            {
              label: "安卓",
              value: "2",
            },
          ],
        },
        {
          column: "版本号",
          key: "version",
          needKeyValue: false,
          caseKey: "pav.version",
        },
        {
          column: "构建编号",
          key: "versionCode",
          needKeyValue: false,
          caseKey: "pav.version_code",
        },
        {
          column: "更新内容",
          key: "remark",
          needKeyValue: false,
          caseKey: "pav.remark",
        },
        {
          column: "下载链接",
          key: "updateUrl",
          needKeyValue: false,
          caseKey: "pav.update_url",
        },
        {
          column: "更新类型",
          key: "updateType",
          needKeyValue: false,
          caseKey: "pav.update_type",
          isCustomList: [
            {
              label: "强制更新",
              value: "1",
            },
            {
              label: "推荐更新",
              value: "2",
            },
          ],
        },
        {
          column: "发布时间",
          key: "releaseTime",
          needKeyValue: false,
          caseKey: "pav.releaseTime",
        },
        {
          column: "更新时间",
          key: "updateTime",
          needKeyValue: false,
          caseKey: "pav.update_time",
        },
      ],
    };
  },
  filters: {
    getTime(time) {
      let arr = time.split("");
      let a = arr.indexOf("T");
      arr.splice(a, 1, " ");
      return arr.join("");
    },
  },
  created() {
    const dispField = this.getSessonValue("APPVersionsManDisplayFied");
    const tableRow = this.getSessonValue("APPVersionsManSortData");
    if (dispField) {
      this.orderConfig = dispField;
    }
    if (tableRow) {
      this.tableDataShow = tableRow;
    } else {
      this.tableDataShow = this.tableRow;
    }
    this.getTableData();
    // this.init();
  },
  methods: {
    edit(rowData) {
      setStore({
        name: "homePageRowData",
        content: rowData,
        type: "session",
      });
      this.$emit("changeComponent", "DetailsInfo");
    },
    changeComponent(rowData, page) {
      setStore({
        name: "rowData",
        content: rowData,
        type: "session",
      });
      this.$emit("changeComponent", page);
    },
    init() {
      this.$store.dispatch("dictList");
    },
    isStatus(row, key) {
      if (key === "status") {
        return row[key];
      }
    },
    handleDelete(row) {
      this.delId = row.id;
      this.noticeModal = true;
    },
    getSessonValue(name) {
      return getStore({
        name: name,
        type: "session",
      });
    },
    // 高级检索
    toHignSearch(res) {
      console.log(res);
      this.hignSearchRes = res;
      this.hignModal = false;
      this.pageIndex = 1;
      this.getTableData();
    },
    // 搜索
    searchInput() {
      this.hignSearchRes = "";
      this.pageIndex = 1;
      this.getTableData();
    },
    // 重置
    resetInput() {
      this.hignSearchRes = "";
      this.pageIndex = 1;
      Object.keys(this.formInline).forEach((key) => {
        if (key === "updateTime") {
          this.formInline[key] = [];
        } else {
          this.formInline[key] = "";
        }
      });
      this.getTableData();
    },
    // 批量选中项变化
    handleSelectChange(selection) {
      console.log(selection);
      this.selectArrList = selection;
    },
    handleSelectDel() {
      if (this.selectArrList.length === 0) {
        this.$message.warning("请选择");
        return;
      }
      const idArr = this.selectArrList.map((item) => item.id);
      this.delId = idArr.join(",");
      this.noticeModal = true;
    },
    // 确认弹窗
    agreeNotice() {
      this.$store
        .dispatch("deleteVersionByIds", { ids: this.delId })
        .then((res) => {
          if (res.data.status === 1000) {
            this.$refs.otherUserId.clearSelection();
            this.getTableData();
            this.$message({
              message: "操作成功！",
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
          this.noticeModal = false;
        });
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    // 返回上级
    goBack() {
      this.$emit("backHome");
    },
    // 关闭弹窗
    closeModal() {
      this.hignModal = false;
    },
    addPage() {
      setStore({
        name: "homePageRowData",
        content: "",
        type: "session",
      });
      this.$emit("changeComponent", "DetailsInfo");
    },
    // 显示高级或者不显示
    changeHign() {
      console.log(this.checked);
    },
    // 切换展示字段
    getTableList(value) {
      this.tableDataShow = value;
    },
    // 改变数据排序
    getDataOrder(value) {
      this.orderConfig = value;
      console.log("改变了数据顺序", this.orderConfig);
      this.getTableData();
    },
    // 高级检索
    hignSearch() {
      this.hignModal = true;
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getTableData();
    },
    // 查询列表
    async getTableData() {
      let dataSortStr = this.orderConfig;
      if (Array.isArray(this.orderConfig)) {
        dataSortStr = this.orderConfig.join(",");
      }
      const startTime = this.formInline.updateTime[0]
        ? this.formInline.updateTime[0]
        : "";
      const endTime = this.formInline.updateTime[1]
        ? this.formInline.updateTime[1]
        : "";
      this.loading = true;
      const serviceList = await this.$store.dispatch("getAppVersionList", {
        versionInfo: {
          appType: this.formInline.appType,
          version: this.formInline.version,
          versionCode: this.formInline.versionCode,
          updateType: this.formInline.updateType,
          updateTimeStart: startTime,
          updateTimeEnd: endTime,
        },
        dataSortStr: dataSortStr, //数据排序
        advancedSearch: this.hignSearchRes,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      });
      this.loading = false;
      const { result } = serviceList.data;
      if (serviceList.data.status === 1000) {
        if (result.records.length !== 0) {
          this.tableData = result.records;
          this.totalNum = Number(result.total);
        } else {
          if (this.pageIndex !== 1) {
            this.pageIndex -= 1;
            this.getTableData();
          } else {
            this.tableData = [];
            this.totalNum = 0;
          }
        }
      } else {
        this.tableData = [];
        this.totalNum = 0;
      }
    },
    getlable(row, key) {
      // console.log(row, key)
      let value = row[key];
      switch (key) {
        case "appType":
          if (row[key] == 1) {
            value = "iOS";
          } else if (row[key] == 2) {
            value = "安卓";
          } else {
            value = "无";
          }
          break;
        case "updateType":
          if (row[key] == 1) {
            value = "强制更新";
          } else if (row[key] == 2) {
            value = "推荐更新";
          } else {
            value = "无";
          }
          break;
        default:
          value = row[key];
          break;
      }
      return value;
    },
    download(src) {
      window.open(src);
    },
  },
};
</script>

<style lang="scss">
.service-list {
  height: calc(100vh - 122px);
}
.tableThree-heightOth {
  .el-table__body-wrapper {
    height: calc(100vh - 229px) !important;
    .tableThree-height-shu {
      display: inline-block;
      padding: 0 4px;
      position: relative;
      .shu-item {
        position: absolute;
        width: 1px;
        height: 12px;
        background-color: #d4d4d7;
        display: inline-block;
        top: -10px;
      }
    }
  }
  .bigImg {
    color: #2d8cf0;
    cursor: pointer;
  }
  .redCorlo {
    color: #ff4d4f;
  }
  .greenCorlo {
    color: #33cc99;
  }
}
.serviceDialog {
  text-align: center;
  img {
    max-width: 100%;
  }
  .el-dialog__body {
    padding: 10px 0 !important;
  }
}
.el-range-editor.el-input__inner {
  width: 216px;
}
</style>
